import React from "react";
import { Modal } from "@mui/material";
import Button from "components/atoms/Button";

import * as Styled from "../ModalConfiguracoesStyles";

type ModalNoServiceChangesProps = {
  isOpen: boolean;
  onClose: () => void;
};

const ModalNoServiceChanges = ({
  isOpen,
  onClose,
}: ModalNoServiceChangesProps) => (
  <Modal closeAfterTransition keepMounted open={isOpen} onClose={onClose}>
    <Styled.Box>
      <Styled.ModalTitle>Aviso</Styled.ModalTitle>
      <Styled.ModalBody>
        Nenhuma alteração foi feita. Para aplicar mudanças, edite as informações
        antes de aplicar.
      </Styled.ModalBody>
      <Styled.ContentActions>
        <Button color="primary" variant="contained" onClick={onClose}>
          ESTOU CIENTE
        </Button>
      </Styled.ContentActions>
    </Styled.Box>
  </Modal>
);

export default ModalNoServiceChanges;
